import { Component, OnInit } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationConfigWithPath } from 'lottie-web';
import * as lottie from 'lottie-web';
import { LoginService } from 'src/app/_clusters/services/login.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit, AfterViewInit {
  showImage: boolean = false;
  ngAfterViewInit() {
    this.loadLottieAnimation();
  }

  loadLottieAnimation() {
    const animationDataUrl =
      'https://assets3.lottiefiles.com/packages/lf20_eFF9SX.json';

    const containerElement = document.getElementById(
      'lottieContainer'
    ) as HTMLElement;

    const animationConfig: AnimationConfigWithPath = {
      container: containerElement,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: animationDataUrl,
    };

    const animation = (lottie as any).loadAnimation(animationConfig);
    animation.setSpeed(2.5);

    containerElement.addEventListener('mouseenter', () => {
      animation.loop = false;
      animation.stop();
    });

    containerElement.addEventListener('mouseleave', () => {
      animation.loop = true;
      animation.goToAndPlay(0);
    });
  }
  constructor(private loginService: LoginService,
    private router: Router) { }

  ngOnInit() {  window.scroll({top:0,left:0,behavior:"smooth"});

  }
  start() {
    this.loginService.updateWelcomeStatus({ isWelcome: 2 }).subscribe((res: any) => {
      if (res && res.status) {
        this.router.navigateByUrl('/game-plan-status-page');
      }
    })
  }

}
